import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import withAuthLayout from "../../hoc/withAuthLayout";
import { yupResolver } from '@hookform/resolvers/yup';
import PasswordIcon from '../../assets/password.svg';
import PasswordHide from '../../assets/password-hide.svg';
import PasswordShow from '../../assets/password-show.svg';
import { resetPasswordValidation } from "../../utils/validations/formValidations";
import AuthContainer from "../../components/ui/AuthContainer";
import { ResetPass } from "../../utils/api";
import { removeFromLocalStorage } from "../../utils/storageUtil";
import { message } from "antd";


const ResetPassword = () => {

    const { state: id } = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [passwordOneVisible, setIsPasswordOneVisible] = useState(false);
    const [passwordTwoVisible, setIsPasswordTwoVisible] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(resetPasswordValidation) });

    const onSubmit = async data => {
        const resetPassData = {
            password: data.confirmPassword
        };

        try {
            setLoading(true);
            const resData = await ResetPass(resetPassData, id);
            if (resData?.isSuccess) {
                message.success(resData?.message);
                removeFromLocalStorage('isEmailVerified');
                removeFromLocalStorage('isOtpVerified');
                setLoading(false);
                navigate('/auth/login');
            } else {
                message.destroy();
                message.error(resData?.error);
                setLoading(false);
            }
        } catch (error) {
            console.error('Login error:', error);
            message.error('An error occurred during login. Please try again later.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthContainer>
            <h2 className="font-bold text-base heading">Reset Password</h2>
            <h4 className="2xl:text-base font-semibold text-xs">Please set new password</h4>
            <p className="text-[12px] 2xl:text-base text-input-placeholder">Enter new password then click select change password</p>
            <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate>
                <div className="2xl:p-4 border border-[#000E2F70] flex gap-x-2 rounded-xl p-3 relative mt-4">
                    <label className="2xl:text-sm absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="password">New Password</label>
                    <img src={PasswordIcon} alt="password-svg" width={12} />
                    <input placeholder="********" className="w-full outline-none text-[12px] text-input-placeholder" type={passwordOneVisible ? "text" : "password"} id="password" {...register('password')} />
                    <img src={passwordOneVisible ? PasswordHide : PasswordShow} alt="password-hide" width={12} className="cursor-pointer" onClick={() => setIsPasswordOneVisible(!passwordOneVisible)} />
                </div>
                <p className="text-[red] text-[12px]">{errors.password?.message}</p>
                <div className="2xl:p-4 border border-[#000E2F70] flex gap-x-2 rounded-xl p-3 relative mt-4">
                    <label className="2xl:text-sm absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="confirmPassword">Confirm Password</label>
                    <img src={PasswordIcon} alt="password-svg" width={12} />
                    <input placeholder="********" className="w-full outline-none text-[12px] text-input-placeholder" type={passwordTwoVisible ? "text" : "password"} id="confirmPassword" {...register('confirmPassword')} />
                    <img src={passwordTwoVisible ? PasswordHide : PasswordShow} alt="password-hide" width={12} className="cursor-pointer" onClick={() => setIsPasswordTwoVisible(!passwordTwoVisible)} />
                </div>
                <p className="text-[red] text-[12px]">{errors.confirmPassword?.message}</p>
                <button type="submit" className="sign-in mt-6 bg-[#E5B3B2] w-max mx-auto text-white text-[10px] px-12 py-3 rounded-lg flex items-center gap-x-2">
                    <span>Done</span>
                    {loading && <span className="loader"></span>}
                </button>
            </form>
        </AuthContainer>
    )
}

export default withAuthLayout(ResetPassword);